
/**
 * 系统配置
 */


// eslint-disable-next-line
export const appConfig = window.__app_config_;